import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllBrands } from '../redux/user/brands/brands_service_syn';
import LoaderScreen from './loader/loaderScreen';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

const BrandLogos = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const { brands, loading } = useSelector((state) => state.brands);

  useEffect(() => {
    dispatch(getAllBrands({ page: 1, limit: 10 }));
  }, [dispatch]);

  const brandsArray = brands?.data?.docs || [];

  const handleBrandClick = (brand) => {
    navigate(`/brand/${brand._id}`, { state: { brandName: brand.name } });
  };

  if (loading) {
    return (
      <div className="brand__logo--section bg__secondary section--padding">
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <LoaderScreen />
          </div>
        </div>
      </div>
    );
  }

  const renderBrandLogo = (brand) => (
    <div 
      key={brand._id} 
      className="brand__logo--items text-center mx-3 my-2"
      onClick={() => handleBrandClick(brand)}
      style={{ cursor: 'pointer' }}
    >
      <div className="p-2">
        <img
          className="brand__logo--items__thumbnail--img mb-2"
          src={brand.brand_image}
          alt={brand.name || "Brand logo"}
          style={{
            width: '100px',
            height: '60px',
            objectFit: 'contain'
          }}
        />
        {brand.name && (
          <p className="brand-name text-white text-center mt-2">{brand.name}</p>
        )}
      </div>
    </div>
  );

  // If no brands are available
  if (brandsArray.length === 0) {
    return (
      <div className="brand__logo--section bg__secondary section--padding">
        <div className="container-fluid text-center">
          <p>No brand logos available</p>
        </div>
      </div>
    );
  }

  // If 6 or fewer brands, display them normally
  if (brandsArray.length <= 6) {
    return (
      <div className="brand__logo--section bg__secondary section--padding">
        <div className="container-fluid">
          <div className="row row-cols-1">
            <div className="col">
              <div className="brand__logo--section__inner d-flex justify-content-center align-items-center flex-wrap">
                {brandsArray.map(renderBrandLogo)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If more than 6 brands, use Swiper
  return (
    <div className="brand__logo--section bg__secondary section--padding">
      <div className="container-fluid">
        <div className="row row-cols-1">
          <div className="col">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 6,
                  spaceBetween: 30,
                },
              }}
              className="brand-logos-swiper"
            >
              {brandsArray.map((brand) => (
                <SwiperSlide key={brand._id}>
                  <div 
                    className="brand__logo--items text-center"
                    onClick={() => handleBrandClick(brand)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="p-2">
                      <img
                        className="brand__logo--items__thumbnail--img mb-2"
                        src={brand.brand_image}
                        alt={brand.name || "Brand logo"}
                        style={{
                          width: '100px',
                          height: '60px',
                          objectFit: 'contain'
                        }}
                      />
                      {brand.name && (
                        <p className="brand-name text-white text-center mt-2">{brand.name}</p>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandLogos;
